import { render, staticRenderFns } from "./edit-buyer-company.vue?vue&type=template&id=fd0b395a"
import script from "./edit-buyer-company.vue?vue&type=script&lang=js"
export * from "./edit-buyer-company.vue?vue&type=script&lang=js"
import style0 from "./edit-buyer-company.vue?vue&type=style&index=0&id=fd0b395a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd0b395a')) {
      api.createRecord('fd0b395a', component.options)
    } else {
      api.reload('fd0b395a', component.options)
    }
    module.hot.accept("./edit-buyer-company.vue?vue&type=template&id=fd0b395a", function () {
      api.rerender('fd0b395a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/edit-buyer-company.vue"
export default component.exports